import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Units } from 'Css';

const css = oxygenCss({
  root: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    flexGrow: 0
  },
  footer: {
    flexGrow: 0
  },
  container: {
    whiteSpace: 'wrap',
    flexGrow: 1,
    overflow: 'auto',
    position: 'relative',
    '&padded': {
      padding: Units.base
    }
  }
});

class ScrollableContainer extends Component {
  static propTypes = {
    header: PropTypes.node,
    footer: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.string,
    padded: PropTypes.bool,
    backgroundColor: PropTypes.string
  };

  render() {
    const {
      padded,
      header,
      footer,
      className,
      children,
      color,
      backgroundColor,
      ...other
    } = this.props;
    const style = backgroundColor || color ? { backgroundColor, color } : null;

    return (
      <div className={classNames(className, css.root)} style={style} {...other}>
        {header && <div className={css.header}>{header}</div>}
        <div className={classNames(css.container, { [css.padded]: padded })}>
          {children}
        </div>
        {footer && <div className={css.footer}>{footer}</div>}
      </div>
    );
  }
}

export default ScrollableContainer;



// WEBPACK FOOTER //
// ./src/js/components/Tasks/ScrollableContainer.js